export function dataUrlToFile(dataUrl: string, filename: string): File {
    const parts = dataUrl.split(',');
    if (parts.length < 2) {
        throw new Error('Invalid data URL');
    }
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch?.[1] ?? 'image/png';
    const bstr = atob(parts[1]);
    const u8 = new Uint8Array(bstr.length);
    for (let i = 0; i < bstr.length; i++) {
        u8[i] = bstr.charCodeAt(i);
    }
    const blob = new Blob([u8], {type: mime});
    return new File([blob], filename, {type: mime});
}
